var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "DeleteDocument" }, [
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c("div", { staticClass: "button-holder" }, [
      _c("button", { staticClass: "btn cancel", on: { click: _vm.cancel } }, [
        _vm._v("Cancel"),
      ]),
      _vm._v(" "),
      _c("button", { staticClass: "btn", on: { click: _vm.deleteDocument } }, [
        _vm._v("Delete"),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "image-block" }, [
      _c("img", { attrs: { src: "/img/warning.png", alt: "" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text" }, [
      _c("p", [_vm._v("Do you really want to delete this document?")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }